import { StepPlaceholder } from '../../../StepPlaceholder/StepPlaceholder';

export const UploadGewerbescheinPage = () => {
    return <StepPlaceholder />;
};
